import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useInstance} from 'react-ioc';
import {useNavigate} from 'react-router-dom';
import {Button, Slider} from 'antd';
import cn from 'classnames';
import dayjs from 'dayjs';
import {observer} from 'mobx-react-lite';

import {REGISTRATION} from '../../../config/routes';
import {Store} from '../../../model/store/Store';
import {CurrencyFormat, CurrencySymbol} from '../../../shared/helpers/currencies';

import img from './banner.jpg';

import cls from './Banner.module.scss'

function getWindowDimensions() {
    const {innerWidth: width, innerHeight: height} = window;
    return {
        width,
        height
    };
}

export const Banner = observer(() => {

    const {t} = useTranslation();
    const {rate} = useInstance(Store)
    const [zaim,setZaim] = useState<number>(3500)
    const [term,setTerm] = useState<number>(15)
    const navigate = useNavigate()

    const [width, setWidth] = useState(getWindowDimensions().width);
    useEffect(() => {
        function handleResize() {
            setWidth(getWindowDimensions().width);
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const CurrencyConvert = (value: number) => Math.round(value * rate.currencyRate() * 100) / 100

    const min = 300 //MXN
    const max = 7000 //MXN
    const step = 100 //MXN

    return (
        <div className={cls.banner} style={{backgroundImage: `url(${width > 768 ? img : undefined})`}}>

            <div className={cn(['highlight', cls.title])}>
                <div className={'bold'}>{'Get Money —'}</div>
                <div>{t('instant online loans, with any credit history')}</div>
            </div>

            <div className={cls.form}>
                <div>
                    <div className={cn([cls.label, 'bold'])}>
                        <div>{t('Loan amount')}</div>
                        <div>{CurrencyFormat(CurrencyConvert(zaim))} {CurrencySymbol(rate.currency)}</div>
                    </div>
                    <Slider tooltip={{formatter: (value) => CurrencyFormat(CurrencyConvert(value!))}} value={zaim} onChange={(value) => setZaim(value)} min={min} max={max} step={step}/>
                    <div className={cn([cls.label, 'caption'])}>
                        <div>{CurrencyFormat(CurrencyConvert(min))} {CurrencySymbol(rate.currency)}</div>
                        <div>{CurrencyFormat(CurrencyConvert(max))} {CurrencySymbol(rate.currency)}</div>
                    </div>
                </div>

                <div>
                    <div className={cn([cls.label, 'bold'])}>
                        <div>{t('Loan term')}</div>
                        <div>{term}</div>
                    </div>
                    <Slider value={term} onChange={(value) => setTerm(value)} min={1} max={30} step={1}/>
                    <div className={cn([cls.label, 'caption'])}>
                        <div>1&nbsp;{t('Day')}</div>
                        <div>30&nbsp;{t('Days')}</div>
                    </div>
                </div>

                <div>
                    <div className={cn([cls.label, 'bold'])}>
                        <div>{t('You return')}</div>
                    </div>
                    <div>
                        <span className={cls.sum}>{CurrencyFormat(CurrencyConvert(zaim + (zaim * term * 0.0008)))} {CurrencySymbol(rate.currency)}</span> {t('until')} {dayjs().add(term, 'day').format('DD.MM.YYYY')}
                    </div>
                </div>

                <div><Button type={'primary'} size={'large'} onClick={() => navigate(REGISTRATION)} block>{t('Apply for a loan')}</Button></div>

            </div>



        </div>
    )
})